export type EventColor = 
  | 'blue'   // Default
  | 'green'  // Success
  | 'red'    // Urgent
  | 'yellow' // Warning
  | 'purple' // Special
  | 'indigo' // Info
  | 'pink'   // Personal
  | 'orange' // Important
  | 'teal'   // General
  | 'gray';  // Other

export interface EventColorConfig {
  name: string;
  bg: string;
  text: string;
  dot: string;
  hover: string;
}

export const eventColors: Record<EventColor, EventColorConfig> = {
  blue: {
    name: 'Blau',
    bg: 'bg-blue-100',
    text: 'text-blue-800',
    dot: 'bg-blue-500',
    hover: 'hover:bg-blue-200'
  },
  green: {
    name: 'Grün',
    bg: 'bg-green-100',
    text: 'text-green-800',
    dot: 'bg-green-500',
    hover: 'hover:bg-green-200'
  },
  red: {
    name: 'Rot',
    bg: 'bg-red-100',
    text: 'text-red-800',
    dot: 'bg-red-500',
    hover: 'hover:bg-red-200'
  },
  yellow: {
    name: 'Gelb',
    bg: 'bg-yellow-100',
    text: 'text-yellow-800',
    dot: 'bg-yellow-500',
    hover: 'hover:bg-yellow-200'
  },
  purple: {
    name: 'Lila',
    bg: 'bg-purple-100',
    text: 'text-purple-800',
    dot: 'bg-purple-500',
    hover: 'hover:bg-purple-200'
  },
  indigo: {
    name: 'Indigo',
    bg: 'bg-indigo-100',
    text: 'text-indigo-800',
    dot: 'bg-indigo-500',
    hover: 'hover:bg-indigo-200'
  },
  pink: {
    name: 'Pink',
    bg: 'bg-pink-100',
    text: 'text-pink-800',
    dot: 'bg-pink-500',
    hover: 'hover:bg-pink-200'
  },
  orange: {
    name: 'Orange',
    bg: 'bg-orange-100',
    text: 'text-orange-800',
    dot: 'bg-orange-500',
    hover: 'hover:bg-orange-200'
  },
  teal: {
    name: 'Türkis',
    bg: 'bg-teal-100',
    text: 'text-teal-800',
    dot: 'bg-teal-500',
    hover: 'hover:bg-teal-200'
  },
  gray: {
    name: 'Grau',
    bg: 'bg-gray-100',
    text: 'text-gray-800',
    dot: 'bg-gray-500',
    hover: 'hover:bg-gray-200'
  }
};